import { createAsyncThunk } from "@reduxjs/toolkit";
import { createHelpModuleListApi, getHelpModuleListApi, updateHelpModuleApi } from "../../apis/helpModule";
import { CreateHelpModulePayloadType, GetHelpModulePayloadType, UpdateHelpModulePayloadType } from "../../commonTypes/helpModuleTypes";

export const getHelpModuleListAction = createAsyncThunk(
    "get/HelpModuleList",
    async (data: GetHelpModulePayloadType) => {
      const response = await getHelpModuleListApi(data);
      return response.data;
    });

    export const createHelpModuleListAction = createAsyncThunk(
        "create/HelpModuleList",
        async (data: CreateHelpModulePayloadType) => {
          const response = await createHelpModuleListApi( data);
          return response.data;
        }
      );

      export const updateHelpModuleAction = createAsyncThunk(
        "update/HelpModuleList",
        async (data: UpdateHelpModulePayloadType) => {
          const response = await updateHelpModuleApi(data);
          return response.data;
        }
      );